import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import FormButton from '@components/form/form-button';
import Layout from '@domain/layout';

import PersonalDataImg from '../../assets/PersonalData.svg';
import Success from '../../assets/success.svg';
import useInterval from '../../hooks/useInterval';
import Image from '@domain/image';
import { useVismaConfiguration } from '@services/visitor-management';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  min-height: 80vh;
  overflow-y: auto;
  padding: 2rem 0;
  & > img {
    width: 70px;
  }
  @media only screen and (max-width: 1200px) {
    & > img {
      width: 56px;
    }
  }
`;

const HeaderText = styled.h3`
  font-size: 21px;
  font-weight: 600;
  color: ${({ theme }) => theme.text};
  margin: 1em 0;

  @media only screen and (max-width: 1200px) {
    margin: 16px 20px;
    text-align: center;
    font-size: 13px;
  }
`;

const HeaderDesc = styled.p`
  padding: 0 4em;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.textSecondary};
  text-align: justify;

  & > b {
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.primary};
  }

  @media only screen and (max-width: 1200px) {
    padding: 0 4em;
    margin: 16px 20px;
    font-size: 11px;
  }

  @media only screen and (max-width: 576px) {
    padding: 0;
  }
`;

const RedirectText = styled.p`
  margin: 2em 0;
  padding: 0 4em;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.textSecondary};
  text-align: justify;

  & > b {
    color: ${({ theme }) => theme.primary};
  }

  @media only screen and (max-width: 1200px) {
    padding: 0 4em;
    margin: 16px 20px;
    font-size: 11px;
  }
`;

const rightPanel = (
  <img
    src={PersonalDataImg}
    alt="final-banner"
    style={{ height: '100%', width: '100%', objectFit: 'contain' }}
  />
);

interface FinalFeatureProps {
  isVisitorRegistration?: boolean;
  isElearningWpOnsite?: boolean;
  onReset?: () => void;
}

function FinalFeature({
  isVisitorRegistration,
  isElearningWpOnsite,
  onReset
}: FinalFeatureProps) {
  const { configuration } = useVismaConfiguration();
  const infoData = configuration?.infoData;
  const intl = useIntl();
  const [leftSecs, setLeftSecs] = useState(7);

  const showTimerAndButton = isVisitorRegistration || isElearningWpOnsite;

  useInterval(() => {
    if (!showTimerAndButton) return;
    if (leftSecs > 0) {
      let newSec = leftSecs - 1;
      if (newSec > 0) {
        setLeftSecs(newSec);
      } else {
        setLeftSecs(0);
        onReset && onReset();
      }
    }
  }, 1000);

  return (
    <Layout
      rightPanel={
        <Image
          id={infoData?.featured_image?.id as string}
          alt="video-banner"
          style={{ height: '100%', width: '100%', objectFit: 'contain' }}
        />
      }
    >
      <Container>
        <img src={Success} alt="success" />
        <HeaderText>
          {configuration?.infoData?.successful_title ?? ''}
        </HeaderText>
        <HeaderDesc
          dangerouslySetInnerHTML={{
            __html: configuration?.infoData?.successful_description ?? ''
          }}
        />
        {showTimerAndButton && (
          <>
            <FormButton
              type="primary"
              onClick={onReset}
              style={{ marginTop: '5em' }}
              withRightArrow
            >
              {intl.formatMessage({ id: 'NEW_CHECK_IN' })}
            </FormButton>
            <RedirectText>
              {intl.formatMessage({ id: 'SUCCESSFUL_MESSAGE' }, { leftSecs })}
            </RedirectText>
          </>
        )}
      </Container>
    </Layout>
  );
}

export default FinalFeature;
